import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Avatar, DropdownMenu } from '@/shared/ui'
import { useAuth } from '@/modules/auth/context/AuthContext'
import { isMasterByEmail } from '@/shared/utils/role'
import { usePwaInstall } from '@/modules/pwa'
import { useNavLinks } from '../hooks/useNavLinks'

export default function UserMenu({ align = 'end' as Align, trigger, side }: { align?: Align; trigger?: React.ReactNode; side?: 'up'|'down' }) {
  const { user, profile, signOut } = useAuth()
  const navigate = useNavigate()
  const { links, effectiveRole } = useNavLinks()
  const name = profile?.full_name || user?.email || 'Usuário'
  const initials = (name || '?').slice(0, 2).toUpperCase()
  const master = isMasterByEmail(user?.email)
  const goProfile = () => navigate('/profile')
  const goManageApp = () => navigate('/gerenciar-app')
  const goSettings = () => navigate('/user-settings')
  const onSignOut = async () => { await signOut(); window.location.replace('/login') }
  const { canInstall, installed, isIosSafari, installing, promptInstall } = usePwaInstall()

  const memberMenuItems = React.useMemo(() => {
    if (effectiveRole !== 'member') return [] as Array<{ label: React.ReactNode; onSelect: () => void }>
    const byPath = new Map(links.map((it) => [it.to, it]))
    const order = ['/assinatura', '/my-plans', '/repasses']
    return order
      .map((path) => byPath.get(path))
      .filter(Boolean)
      .map((item) => ({ label: <span>{item!.label}</span>, onSelect: () => navigate(item!.to) }))
  }, [effectiveRole, links, navigate])

  const items = [
    { label: <div className="text-sm"><div className="font-medium">{name}</div><div className="text-foreground/70">{user?.email}</div></div>, disabled: true },
    ...(canInstall && !installed && !isIosSafari ? [
      { label: <span>{installing ? 'Instalando…' : 'Instalar app'}</span>, onSelect: ()=> void promptInstall() },
    ] : []),
    ...memberMenuItems,
    { label: <span>Gerenciar APP</span>, onSelect: goManageApp },
    { label: <span>Perfil</span>, onSelect: goProfile },
    { label: <span>Configurações</span>, onSelect: goSettings },
    { label: <span className="text-destructive">Sair</span>, onSelect: onSignOut },
  ] as const

  return (
    <div className="flex items-center gap-2">
      <DropdownMenu align={align} side={side}
        trigger={trigger ?? (<Avatar alt={name} fallback={initials} src={profile?.avatar_url || undefined} />)}
        items={[...items]}
      />
    </div>
  )
}

type Align = 'start'|'center'|'end'
